import {
  DrawerOverlay,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  Stack,
  Button,
} from "@chakra-ui/react";
import { Field, Form } from "@saas-ui/react";
import { useState } from "react";
import { useError } from "../../hooks/useError";
import { useSuccess } from "../../hooks/useSuccess";
import { Api } from "../../utils/Api";
import { settlementValidationSchema } from "../../utils/form";
import {
  SETTLEMENT_TYPE_OPTIONS,
  SOURCE_CRYPTO_EXCHANGE_OPTIONS,
  SOURCE_FI_OPTIONS,
  TARGET_CRYPTO_EXCHANGE_OPTIONS,
  TARGET_FI_OPTIONS,
} from "../../utils/typings";

interface props {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
}

interface Values {
  email: string;
  password: string;
}

export const CreateDrawer = ({ isOpen, onClose, onOpen, ...rest }: props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { handleSuccess } = useSuccess();
  const { handleError } = useError();

  const onSubmit = async (values: Values) => {
    try {
      const { data } = await Api.createSettlement(values);
      onClose();
      handleSuccess("Settlement successfully created");
    } catch (error) {
      handleError(error);
      return;
    }
  };

  return (
    <Drawer onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        maxW={{ base: "90%", md: "50%", lg: "35%" }}
        bg="white"
        color="#54565A"
      >
        <DrawerHeader
          borderBottomWidth="1px"
          justifyContent="space-between"
          w="full"
        >
          New Settlement
        </DrawerHeader>
        <DrawerBody>
          <Form schema={settlementValidationSchema} onSubmit={onSubmit}>
            <Stack spacing="6">
              <Stack spacing="5">
                <Field
                  name="settlementType"
                  placeholder="Settlement Type"
                  type="select"
                  label="Settlement Type*"
                  options={SETTLEMENT_TYPE_OPTIONS}
                />
                <Field
                  name="sourceFi"
                  placeholder="Select one"
                  type="select"
                  label="Source FI"
                  options={SOURCE_FI_OPTIONS}
                />
                <Field
                  name="targetFi"
                  placeholder="Select one"
                  type="select"
                  label="Target FI*"
                  options={TARGET_FI_OPTIONS}
                />
                <Field
                  name="sourceCcy"
                  placeholder="Source Currency"
                  type="text"
                  label="Source Currency*"
                />
                <Field
                  name="transferCryptoCcy"
                  placeholder="Transfer Cryptocurrency"
                  type="text"
                  label="Transfer Cryptocurrency*"
                />
                <Field
                  name="targetFiatCcy"
                  placeholder="Target Fiat Currency"
                  type="text"
                  label="Target Fiat Currency*"
                />
                <Field
                  name="settlementAmt"
                  placeholder="Settlement Amount"
                  type="number"
                  label="Settlement Amount*"
                />
                <Field
                  name="receivedAmt"
                  placeholder="Received Amount"
                  type="number"
                  label="Received Amount*"
                />
                <Field
                  name="almondFee"
                  placeholder="Almond fee"
                  type="number"
                  label="Almond fee*"
                />
                <Field
                  name="sourceCryptoExchange"
                  placeholder="Source Crypto Exchange"
                  type="select"
                  label="Source Crypto Exchange"
                  options={SOURCE_CRYPTO_EXCHANGE_OPTIONS}
                />
                <Field
                  name="targetCryptoExchange"
                  placeholder="Target Crypto Exchange"
                  type="select"
                  label="Target Crypto Exchange*"
                  options={TARGET_CRYPTO_EXCHANGE_OPTIONS}
                />
              </Stack>
              <Stack spacing="6" direction="row" w="100%">
                <Button
                  type="submit"
                  isLoading={isSubmitting}
                  bg="#00AE42"
                  w="100%"
                >
                  Create
                </Button>
              </Stack>
            </Stack>
          </Form>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
